import { AuthConfig } from '@spartacus/core';

const SITE_AUTH_MAP: Array<{
  pathPrefix: string;
  oauthClientId: string;
  redirectUriPath: string;
}> = [
  { pathPrefix: '/rfde/', oauthClientId: 'uig_de_client', redirectUriPath: '/rfde/de/EUR' },
  { pathPrefix: '/rfat/', oauthClientId: 'uig_at_client', redirectUriPath: '/rfat/de/EUR' },
  { pathPrefix: '/rfnl/', oauthClientId: 'uig_nl_client', redirectUriPath: '/rfnl/nl/EUR' },
];

function getSiteAuthFromPath(pathname: string): { oauthClientId: string; redirectUriPath: string } | null {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;

  for (const site of SITE_AUTH_MAP) {
    if (normalizedPath.startsWith(site.pathPrefix)) {
      return { oauthClientId: site.oauthClientId, redirectUriPath: site.redirectUriPath };
    }
  }

  return null;
}

function getSiteAuthConfig(): { oauthClientId: string; redirectUriPath: string } | null {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const fromPath = getSiteAuthFromPath(pathname);

  if (fromPath) {
    return fromPath;
  }

  return null;
}

function getClientId(): string | undefined {
  return getSiteAuthConfig()?.oauthClientId || '';
}

function getRedirectUri(): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const siteAuth = getSiteAuthConfig();
  const redirectUriPath = siteAuth?.redirectUriPath || '';
  const path = redirectUriPath.startsWith('/') ? redirectUriPath : `/${redirectUriPath}`;

  return path ? `${origin}${path}`.replace(/\/+$/, '') : origin;
}

export const uigAuthConfig: AuthConfig = {
  authentication: {
    client_id: getClientId(),
    OAuthLibConfig: {
      redirectUri: getRedirectUri(),
    },
  },
};
